"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Add = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Add = ({ colour = "#8BD941", size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size, fill: colour, smooth: true },
    react_1.default.createElement("polygon", { points: "13,7 13,9 9,9 9,13 7,13 7,9 3,9 3,7 7,7 7,3 9,3 9,7 " })));
exports.Add = Add;
//# sourceMappingURL=Add.js.map